/**
 * Telemetry — optional event sink for match lifecycle.
 *
 * Disabled by default. Pass `bootGame({ telemetry: (event) => fetch(...) })`
 * to opt in. Standard event names:
 *
 *   - boot
 *   - match-started
 *   - match-ended      (with { durationSec, winnerId, scores })
 *   - player-joined
 *   - player-left
 *   - error
 */
export class Telemetry {
  constructor(sink) {
    this.sink = sink || null;
  }

  emit(name, payload) {
    if (!this.sink) return;
    try {
      this.sink({ name, payload, ts: Date.now() });
    } catch (_) { /* swallow */ }
  }
}
